export const educationData = [
  {
    id: 1,
    institution: "Université de Bordeaux",
    course: "Master Enterprise Engineering",
    startYear: "2018",
    endYear: "2019",
  },
  {
    id: 2,
    institution: "Louisiana State University",
    course: "Minor in Software Engineering",
    startYear: "2016",
    endYear: "2017",
  },
  {
    id: 3,
    institution: "Universidad Carlos III",
    course: "Bachelor of Engineering Technology",
    startYear: "2013",
    endYear: "2018",
  },
];
